module.exports = __webpack_public_path__ + "static/media/ramla.db3a1dbb.mp3";